(function (_, $module$_js_joda_core_gcv2k, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var Instant = $module$_js_joda_core_gcv2k.Instant;
  var Clock = $module$_js_joda_core_gcv2k.Clock;
  var OffsetDateTime = $module$_js_joda_core_gcv2k.OffsetDateTime;
  var objectMeta = kotlin_kotlin.$_$.y9;
  var interfaceMeta = kotlin_kotlin.$_$.e9;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.x1;
  var captureStack = kotlin_kotlin.$_$.p8;
  var IllegalArgumentException = kotlin_kotlin.$_$.oc;
  var classMeta = kotlin_kotlin.$_$.v8;
  var Long = kotlin_kotlin.$_$.qc;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var THROW_CCE = kotlin_kotlin.$_$.vc;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.t2;
  var indexOf$default = kotlin_kotlin.$_$.q;
  var charSequenceLength = kotlin_kotlin.$_$.t8;
  var charSequenceGet = kotlin_kotlin.$_$.s8;
  var Char = kotlin_kotlin.$_$.gc;
  var equals = kotlin_kotlin.$_$.x8;
  var Unit_getInstance = kotlin_kotlin.$_$.k4;
  var _Duration___get_inWholeSeconds__impl__hpy7b3 = kotlin_kotlin.$_$.r2;
  var _Duration___get_nanosecondsComponent__impl__nh19kq = kotlin_kotlin.$_$.s2;
  var numberToDouble = kotlin_kotlin.$_$.v9;
  var numberToInt = kotlin_kotlin.$_$.w9;
  var Comparable = kotlin_kotlin.$_$.hc;
  //endregion
  //region block: pre-declaration
  DateTimeFormatException.prototype = Object.create(IllegalArgumentException.prototype);
  DateTimeFormatException.prototype.constructor = DateTimeFormatException;
  //endregion
  function System() {
    System_instance = this;
  }
  System.prototype.r4y = function () {
    return Companion_getInstance().r4y();
  };
  System.$metadata$ = objectMeta('System', [Clock_0]);
  var System_instance;
  function System_getInstance() {
    if (System_instance == null)
      new System();
    return System_instance;
  }
  function Clock_0() {
  }
  Clock_0.$metadata$ = interfaceMeta('Clock');
  function DateTimeFormatException_init_$Init$(cause, $this) {
    IllegalArgumentException_init_$Init$(cause, $this);
    DateTimeFormatException.call($this);
    return $this;
  }
  function DateTimeFormatException_init_$Create$(cause) {
    var tmp = DateTimeFormatException_init_$Init$(cause, Object.create(DateTimeFormatException.prototype));
    captureStack(tmp, DateTimeFormatException_init_$Create$);
    return tmp;
  }
  function DateTimeFormatException() {
    captureStack(this, DateTimeFormatException);
  }
  DateTimeFormatException.$metadata$ = classMeta('DateTimeFormatException', undefined, undefined, undefined, undefined, IllegalArgumentException.prototype);
  function get_DISTANT_PAST_SECONDS() {
    return DISTANT_PAST_SECONDS;
  }
  var DISTANT_PAST_SECONDS;
  function get_DISTANT_FUTURE_SECONDS() {
    return DISTANT_FUTURE_SECONDS;
  }
  var DISTANT_FUTURE_SECONDS;
  function InstantIso8601Serializer() {
    InstantIso8601Serializer_instance = this;
    this.w4y_1 = PrimitiveSerialDescriptor('Instant', STRING_getInstance());
  }
  InstantIso8601Serializer.prototype.g2e = function () {
    return this.w4y_1;
  };
  InstantIso8601Serializer.prototype.i2e = function (decoder) {
    return Companion_getInstance().a1y(decoder.y2g());
  };
  InstantIso8601Serializer.prototype.x4y = function (encoder, value) {
    encoder.d2i(value.toString());
  };
  InstantIso8601Serializer.prototype.h2e = function (encoder, value) {
    return this.x4y(encoder, value instanceof Instant_0 ? value : THROW_CCE());
  };
  InstantIso8601Serializer.$metadata$ = objectMeta('InstantIso8601Serializer', [KSerializer]);
  var InstantIso8601Serializer_instance;
  function InstantIso8601Serializer_getInstance() {
    if (InstantIso8601Serializer_instance == null)
      new InstantIso8601Serializer();
    return InstantIso8601Serializer_instance;
  }
  function fixOffsetRepresentation($this, isoString) {
    var tmp = _Char___init__impl__6a9atx(84);
    var time = indexOf$default(isoString, tmp, 0, true, 2, null);
    if (time === -1)
      return isoString;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.indexOfLast' call
      var inductionVariable = charSequenceLength(isoString) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp$ret$0;
          // Inline function 'kotlinx.datetime.Companion.fixOffsetRepresentation.<anonymous>' call
          var tmp0__anonymous__q1qw7t = charSequenceGet(isoString, index);
          tmp$ret$0 = equals(new Char(tmp0__anonymous__q1qw7t), new Char(_Char___init__impl__6a9atx(43))) ? true : equals(new Char(tmp0__anonymous__q1qw7t), new Char(_Char___init__impl__6a9atx(45)));
          if (tmp$ret$0) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$1 = -1;
    }
    var offset = tmp$ret$1;
    if (offset < time)
      return isoString;
    var tmp_0 = _Char___init__impl__6a9atx(58);
    var separator = indexOf$default(isoString, tmp_0, offset, false, 4, null);
    return !(separator === -1) ? isoString : isoString + ':00';
  }
  function Companion() {
    Companion_instance = this;
    this.s4y_1 = new Instant_0(Instant.ofEpochSecond(get_DISTANT_PAST_SECONDS(), 999999999));
    this.t4y_1 = new Instant_0(Instant.ofEpochSecond(get_DISTANT_FUTURE_SECONDS(), 0));
    this.u4y_1 = new Instant_0(Instant.MIN);
    this.v4y_1 = new Instant_0(Instant.MAX);
  }
  Companion.prototype.r4y = function () {
    return new Instant_0(Clock.systemUTC().instant());
  };
  Companion.prototype.a1y = function (isoString) {
    var tmp;
    try {
      tmp = new Instant_0(OffsetDateTime.parse(fixOffsetRepresentation(this, isoString)).toInstant());
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        if (isJodaDateTimeParseException($p))
          throw DateTimeFormatException_init_$Create$($p);
        throw $p;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  Companion.$metadata$ = objectMeta('Companion');
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Instant_0(value) {
    Companion_getInstance();
    this.y4y_1 = value;
  }
  Instant_0.prototype.z4y = function (duration) {
    var tmp$ret$0;
    // Inline function 'kotlin.time.Duration.toComponents' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0__anonymous__q1qw7t = _Duration___get_inWholeSeconds__impl__hpy7b3(duration);
    var tmp1__anonymous__uwfjfc = _Duration___get_nanosecondsComponent__impl__nh19kq(duration);
    var tmp;
    try {
      tmp = new Instant_0(this.a4z(tmp0__anonymous__q1qw7t.ni(), tmp1__anonymous__uwfjfc));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        if (!isJodaDateTimeException($p))
          throw $p;
        tmp_0 = tmp0__anonymous__q1qw7t.f1(new Long(0, 0)) > 0 ? Companion_getInstance().v4y_1 : Companion_getInstance().u4y_1;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
    return tmp$ret$0;
  };
  Instant_0.prototype.a4z = function (seconds, nanos) {
    var newSeconds = numberToDouble(this.y4y_1.epochSecond()) + seconds;
    var newNanos = numberToDouble(this.y4y_1.nano()) + nanos;
    return Instant.ofEpochSecond(newSeconds, newNanos);
  };
  Instant_0.prototype.b4z = function (other) {
    return numberToInt(this.y4y_1.compareTo(other.y4y_1));
  };
  Instant_0.prototype.d9 = function (other) {
    return this.b4z(other instanceof Instant_0 ? other : THROW_CCE());
  };
  Instant_0.prototype.equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof Instant_0) {
        tmp_0 = equals(this.y4y_1, other.y4y_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  Instant_0.prototype.hashCode = function () {
    return numberToInt(this.y4y_1.hashCode());
  };
  Instant_0.prototype.toString = function () {
    return this.y4y_1.toString();
  };
  Instant_0.$metadata$ = classMeta('Instant', [Comparable], undefined, {0: InstantIso8601Serializer_getInstance});
  function isJodaDateTimeException(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    return tmp$ret$0.name == 'DateTimeException';
  }
  function isJodaDateTimeParseException(_this__u8e3s4) {
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    return tmp$ret$0.name == 'DateTimeParseException';
  }
  //region block: init
  DISTANT_PAST_SECONDS = new Long(-931914497, -750);
  DISTANT_FUTURE_SECONDS = new Long(1151527680, 720);
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = InstantIso8601Serializer_getInstance;
  _.$_$.b = System_getInstance;
  //endregion
  return _;
}(module.exports, require('@js-joda/core'), require('./kotlin-kotlin-stdlib-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-core-js-ir.js')));

